import PortalView from './containers/PortalView.js';

export default PortalView;
